export default __webpack_public_path__ + "static/media/47.38a35def.png";